import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentDetail } from '../models/documentVersionDetail';
import { NextPhase } from '../models/nextPhase';
import { DocumentService } from '../services/document.service';
import { DocumentPersistenceService } from '../services/document-persistence.service';

@Component({
  selector: 'app-document-request-effective-date-modal',
  templateUrl: './document-request-effective-date-modal.component.html',
  styleUrls: ['./document-request-effective-date-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class DocumentRequestEffectiveDateModalComponent implements OnInit {
  readonly effectiveDateModalText = `The default Effective Date is 14 days after final approval, however you can
  set a Requested Effective Date for this Document Version if needed. The
  Approver will be able to update the Effective Date in any case.`
  requestedEffectiveDate : any;
  minDateValue: Date = new Date();
  selectedRequestEffectiveDate: Date|null = new Date();
  number!: string;
  @Output() isReasonForChangeModalVisible=new EventEmitter<boolean>();
  @Output() setDocumentDetailsLoader = new EventEmitter<any>();
  @Input() documentNumber!:string;
  docNextPhase!:NextPhase;
  documentDetails!:DocumentDetail
  @Input() documentVersion!:string

  constructor(private router: Router, private documentsservice: DocumentService, private messageService: MessageService, private documentPersistenceService: DocumentPersistenceService) {
    
   } 

  ngOnInit(): void {
        this.minDateValue.setDate(new Date().getDate() + 1);
        this.selectedRequestEffectiveDate=null;
        var url = this.router.url;
    var urlParts = this.router.parseUrl(url);
    this.number = urlParts.queryParams['number'];
  }

  display: boolean = true;

  reloadDocumentDetail(){
    this.isReasonForChangeModalVisible.emit(true);
  }
  showDialog() {
      this.display = true;
  }
  saveDate()
  {     
    this.setDocumentDetailsLoader.emit(true);
    this.docNextPhase = {
      RequestedEffectiveDate: this.selectedRequestEffectiveDate ? this.documentPersistenceService.conversionOfDateIntoLocalDateTime(new Date(this.selectedRequestEffectiveDate)) : null
   };

    this.documentsservice.moveDocumentToNextPhase(this.documentNumber,Number(this.documentVersion),this.docNextPhase)
    .pipe(
      catchError((err) => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: `${err.error}`,
        });
        this.setDocumentDetailsLoader.emit(false);
        return throwError(() => err);
      })
    )  
    .subscribe(() =>{
        this.isReasonForChangeModalVisible.emit(true);
        this.display = false;
      });
  }
}
